import React, { useState, useEffect, useRef } from 'react'
import "./NavBar.css"
import logo from "../../assests/images/ChatGPT Image Jun 12, 2025, 12_33_20 AM.png"
import { Link } from 'react-router-dom'
import { HashLink } from 'react-router-hash-link'



const NavBar = () => {
  const [navExpanded, setNavExpanded] = useState(false)

  const navRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setNavExpanded(false);
      }
    }

    if (navExpanded) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [navExpanded]);

  return (
    <nav ref={navRef}>
      <div className='NavContain'>
        <a href='/#Home'><img className='NavLogo' src={logo} alt="logo is the intials AG in rainbow colors"></img></a>
        <ul className={!navExpanded ? "NavBar" : "NavBar open"}>
          
          <li><HashLink smooth to='/#Projects'>Projects</HashLink></li>
          <li> <HashLink smooth to="/#Work-History">About</HashLink></li>
          <li><Link to='/resume'> <a>Work History</a></Link></li>
          {/* <li><a href="/#ContactMe">Contact Me</a></li> */}
        </ul>
        <button className={!navExpanded ? "NavButton" : "NavButton open"} onClick={() => setNavExpanded(!navExpanded)}>
          <span className='navButLine line1'></span>
          <span className='navButLine line2'></span>
          <span className='navButLine line3'></span>
        </button>
      </div>
      <div className='underLine'></div>
    </nav>

  )
}

export default NavBar